import React from "react";

export const Hidden = (props: any): JSX.Element => {
  return <>{!props.hide && <>{props.children}</>}</>;
};
